import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  constructor(private _http: HttpClient, private _router: Router) { }

  login(body: any){
    return this._http.post<any>(environment.apiUrl + '/users/login',body,{
      observe:'body'
    })
  }

  logout(){
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    this._router.navigate(['auth/login']);
  }

  getUserPermissions(){
    return this._http.get<any>(environment.apiUrl + '/users/permissions',{
      observe:'body',
      params: new HttpParams().append('token',localStorage.getItem('token'))
    })
  }

  getTokenData(){
    return this._http.get<any>(environment.apiUrl + '/users/tokenData',{
      observe:'body',
      params: new HttpParams().append('token',localStorage.getItem('token'))
    })
  }

}
